import { createIcon } from "@chakra-ui/react";

const TwotoneCheckIcon = createIcon({
  displayName: "TwotoneCheckIcon",
  viewBox: "0 0 24 24",
  path: <path d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41L9 16.17z" fill="currentColor" />,
});

export default TwotoneCheckIcon;
